namespace RecordShield.Workspace {
    export interface ProductSerialsRow {
        Id?: number;
        ProductId?: number;
        SerialKey?: string;
        UserId?: number;
        Views?: number;
        WatchTime?: number;
        ValidityInDays?: number;
        UpdateFrequencyInDays?: number;
        AllowSecondScreen?: boolean;
        IsActive?: number;
        Status?: Modules.Workspace.SerialKeys.KeyStatus;
        eViews?: Models.EViews;
        eWatchTime?: Models.EWatchTime;
        eValidity?: Models.EValidity;
        AllowedDevices?: Models.Enums.AllowedDevices;
        GenType?: number;
        GenById?: number;
        GeneratedBy?: number;
        AccessStatus?: Modules.Workspace.SerialKeys.AccessStatus;
        SerialKeyItems?: number[];
        TotalAllowedDuration?: number;
        TenantId?: number;
        ProductCode?: number;
        ProductName?: string;
        ProductDescription?: string;
        ProductUserId?: number;
        ProductViews?: number;
        ProductWatchTime?: number;
        ProductSize?: number;
        ProductValidityInDays?: number;
        ProductUpdateFrequencyInDays?: number;
        ProductAllowSecondScreen?: boolean;
        IsFranchisee?: boolean;
        ProductInsertDate?: string;
        ProductInsertUserId?: number;
        ProductUpdateDate?: string;
        ProductUpdateUserId?: number;
        ProductIsActive?: number;
        Note?: string;
        ProductAuthorName?: string;
        TenantName?: string;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserPasswordHash?: string;
        UserPasswordSalt?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserIsdCode?: string;
        UserMobile?: string;
        UserCustomerKey?: number;
        UserParentId?: number;
        UserPackageId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductSerialsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Workspace.ProductSerials';
        export const lookupKey = 'Workspace.ProductSerials';

        export function getLookup(): Q.Lookup<ProductSerialsRow> {
            return Q.getLookup<ProductSerialsRow>('Workspace.ProductSerials');
        }

        export namespace Fields {
            export declare const Id: string;
            export declare const ProductId: string;
            export declare const SerialKey: string;
            export declare const UserId: string;
            export declare const Views: string;
            export declare const WatchTime: string;
            export declare const ValidityInDays: string;
            export declare const UpdateFrequencyInDays: string;
            export declare const AllowSecondScreen: string;
            export declare const IsActive: string;
            export declare const Status: string;
            export declare const eViews: string;
            export declare const eWatchTime: string;
            export declare const eValidity: string;
            export declare const AllowedDevices: string;
            export declare const GenType: string;
            export declare const GenById: string;
            export declare const GeneratedBy: string;
            export declare const AccessStatus: string;
            export declare const SerialKeyItems: string;
            export declare const TotalAllowedDuration: string;
            export declare const TenantId: string;
            export declare const ProductCode: string;
            export declare const ProductName: string;
            export declare const ProductDescription: string;
            export declare const ProductUserId: string;
            export declare const ProductViews: string;
            export declare const ProductWatchTime: string;
            export declare const ProductSize: string;
            export declare const ProductValidityInDays: string;
            export declare const ProductUpdateFrequencyInDays: string;
            export declare const ProductAllowSecondScreen: string;
            export declare const IsFranchisee: string;
            export declare const ProductInsertDate: string;
            export declare const ProductInsertUserId: string;
            export declare const ProductUpdateDate: string;
            export declare const ProductUpdateUserId: string;
            export declare const ProductIsActive: string;
            export declare const Note: string;
            export declare const ProductAuthorName: string;
            export declare const TenantName: string;
            export declare const UserUsername: string;
            export declare const UserDisplayName: string;
            export declare const UserEmail: string;
            export declare const UserSource: string;
            export declare const UserPasswordHash: string;
            export declare const UserPasswordSalt: string;
            export declare const UserInsertDate: string;
            export declare const UserInsertUserId: string;
            export declare const UserUpdateDate: string;
            export declare const UserUpdateUserId: string;
            export declare const UserIsActive: string;
            export declare const UserLastDirectoryUpdate: string;
            export declare const UserUserImage: string;
            export declare const UserIsdCode: string;
            export declare const UserMobile: string;
            export declare const UserCustomerKey: string;
            export declare const UserParentId: string;
            export declare const UserPackageId: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'ProductId', 'SerialKey', 'UserId', 'Views', 'WatchTime', 'ValidityInDays', 'UpdateFrequencyInDays', 'AllowSecondScreen', 'IsActive', 'Status', 'eViews', 'eWatchTime', 'eValidity', 'AllowedDevices', 'GenType', 'GenById', 'GeneratedBy', 'AccessStatus', 'SerialKeyItems', 'TotalAllowedDuration', 'TenantId', 'ProductCode', 'ProductName', 'ProductDescription', 'ProductUserId', 'ProductViews', 'ProductWatchTime', 'ProductSize', 'ProductValidityInDays', 'ProductUpdateFrequencyInDays', 'ProductAllowSecondScreen', 'IsFranchisee', 'ProductInsertDate', 'ProductInsertUserId', 'ProductUpdateDate', 'ProductUpdateUserId', 'ProductIsActive', 'Note', 'ProductAuthorName', 'TenantName', 'UserUsername', 'UserDisplayName', 'UserEmail', 'UserSource', 'UserPasswordHash', 'UserPasswordSalt', 'UserInsertDate', 'UserInsertUserId', 'UserUpdateDate', 'UserUpdateUserId', 'UserIsActive', 'UserLastDirectoryUpdate', 'UserUserImage', 'UserIsdCode', 'UserMobile', 'UserCustomerKey', 'UserParentId', 'UserPackageId', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
